import React, { useEffect } from "react";
import { Spin } from "antd";
import "firebase/auth";
import { getTenant } from "../../api/server";
import { configurations } from "../../api/auth";

const Verify = (props) => {
  useEffect(() => {
    async function getTenantDetails() {
      const urlParams = new URLSearchParams(window.location.search);
      const tenantId = urlParams.get("tenantId");
      let tenant = {};
      let url = "";
      const str = window.location.href.split("verify_email").pop();
      if (tenantId.startsWith("master") || tenantId.startsWith("test-master")) {
        if (window.location.host === "localhost:3000") {
          url = `http://localhost:3000/change_password${str}`;
        } else {
          url = `https://${
            configurations[process.env.REACT_APP_CONFIG].masterDomain
          }/change_password${str}`;
        }
      } else {
        tenant = await getTenant(tenantId);
        if (tenant.domain === "localhost") {
          if (tenant.microsoft_auth_provider_enabled) {
            url = `http://localhost:3000/link_provider${str}`;
          } else {
            url = `http://localhost:3000/change_password${str}`;
          }
        } else {
          if (tenant.microsoft_auth_provider_enabled) {
            url = `https://${tenant.domain}/link_provider${str}`;
          } else {
            url = `https://${tenant.domain}/change_password${str}`;
          }
        }
      }
      window.location.href = url;
    }
    getTenantDetails();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        height: "100vh",
        alignItems: "center",
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Verify;
